import React from 'react';
import { useLocale } from '@/presentation/contexts/LocaleContext';
import { useResponsiveDesign } from '@/presentation/responsiveDesign/responsiveDesign';
import { qaAttr } from '@/presentation/utils/qaAttr';
import { ButtonSize, ButtonVariant, ExpauseButton } from '@/presentation/components/common/controls/ExpauseButton';

export interface UserDetailsEmptyOwnVideosProps {
  onAddVideo: () => void;
  onShareApp: () => void;
}

export const UserDetailsEmptyOwnVideos: React.FC<UserDetailsEmptyOwnVideosProps> = ({
  onAddVideo,
  onShareApp,
}) => {
  const { l10n } = useLocale();
  const responsive = useResponsiveDesign();

  return (
    <div
      {...qaAttr({ id: 'user-details-empty-videos' })}
      className="flex flex-col"
      style={{
        padding: `${responsive.gap['6xl']}px`,
        gap: responsive.gap.base,
      }}
    >
      <ExpauseButton
        {...qaAttr({ id: 'user-details-empty-add-video' })}
        size={ButtonSize.large}
        onClick={onAddVideo}
      >
        {l10n.userDetails.addFirstVideo}
      </ExpauseButton>
      <ExpauseButton
        {...qaAttr({ id: 'user-details-empty-share' })}
        size={ButtonSize.large}
        variant={ButtonVariant.secondary}
        onClick={onShareApp}
      >
        {l10n.userDetails.shareExpause}
      </ExpauseButton>
    </div>
  );
};
